"use client";

import ImageComponent from "@/components/ui/ImageComponent"
import Link from "next/link"
import { IoCallOutline } from "react-icons/io5"
import { useDispatch } from "react-redux"
import { openModal } from "@/redux/slices/allModalSlice"

export interface StoreGalleryImage {
    url: string
    alt_text: string
}

export interface StoreDetailCardProps {
    imageUrl: string
    heading: string,
    time: string,
    address: string,
    phoneNumber: string,
    mapLink: string,
    virtualTourLink?: string|null,
    galleryImages: StoreGalleryImage[]
    stateRegion: string,
    city: string
    alt_text: string
}

const StoreDetailCard = ({ heading, address, phoneNumber, imageUrl, mapLink, virtualTourLink, galleryImages, city,alt_text }: StoreDetailCardProps) => {

    const dispatch = useDispatch();

    const handleViewGallery = () => {
        if (galleryImages?.length) {
            dispatch(openModal({
                componentName: "ViewImagesModal",
                data: { images: galleryImages, initialIndex: 0 },
            }));
        }
    };

    return (
        <>
            <div className="border-1 border-lightSliver rounded-[10px] md:rounded-3xl p-3 md:p-5 lg:p-6 bg-white h-full">
                <div className="flex justify-between gap-3 md:gap-5 flex-nowrap items-stretch h-full">
                    
                    {/* w-[100px] md:w-[150px]  2xl:w-[250px] */}
                    <div className="h-auto w-[150px] md:w-[200px]  2xl:w-[250px] rounded-[3.97px] md:rounded-[14px] overflow-hidden shrink-0">
                        <ImageComponent url={imageUrl || "/images/home_data/banner_1.png"} img_title={alt_text || heading || "store_name"} />
                    </div>

                    <div className="space-y-2 md:space-y-5 flex-1 items-stretch">
                        <div className="flex flex-col justify-between items-stretch  h-full main_heading_description_space_y">
                            <span className="flex justify-between items-start">
                                <h3 className="text-sm md:text-lg/[121%] 2xl:text-2xl/[121%] font-bold text-textf1 text-wrap flex-1">{heading}</h3>
                                {/* <Link className="flex gap-0 md:gap-1 items-center cursor-pointer" href={`${mapLink}`} rel="noopener noreferrer" target="_blank">
                                    <span className="h-4 md:h-5 w-4 md:w-5 flex shrink-0">
                                        <ImageComponent url="/images/home_data/google_map_logo.png" img_title="Google Maps" object_cover={false} width={20} height={20} />
                                    </span>
                                    <span className="text-[11px] md:text-base lg:text-[13px]/[20px] 2xl:text-lg/[26px] font-semibold text-textf1">Get Direction</span>
                                </Link> */}
                            </span>
                            <div className="space-y-2.5">
                                <p className="text-[11px]  md:text-base lg:text-sm/[22px] 2xl:text-lg/[32px] text-textf1 font-bold">{city}</p>
                                <p className="text-[11px] md:text-base lg:text-sm/[22px] 2xl:text-lg/[32px] text-textf2 font-normal line-clamp-2 text-wrap">{address}</p>
                            </div>
                            <div className="flex justify-between flex-wrap gap-y-2">
                                <Link className="flex gap-0 md:gap-1 items-center cursor-pointer" href={`tel:${phoneNumber.replace(/\s/g, '')}`}>
                                    <span><IoCallOutline className="text-xs md:text-[20px]" /></span>
                                    <span className="text-[11px] md:text-base lg:text-[13px]/[20px] 2xl:text-lg/[26px] font-semibold text-textf1">{phoneNumber}</span>
                                </Link>
                            </div>
                            <div className="flex border-[0.8px] border-silverBlue justify-evenly items-center rounded-full px-2 xl:px-4 2xl:px-6 py-1 md:py-2 lg:py-3">
                                {/* <span className="text-[10px] lg:text-base/[24px]! font-medium text-silverBlue text-center">Get Direction</span>
                                <span className="text-[10px] lg:text-base/[24px]! font-medium text-silverBlue text-center">|</span> */}
                                <span className="text-[10px] md:text-sm lg:text-base/[24px]! font-medium text-silverBlue text-center cursor-pointer" onClick={() => handleViewGallery()}>View Gallery</span>
                                <span className="text-[10px] md:text-sm xl:text-base/[24px]! font-medium text-silverBlue text-center">|</span>
                                {/* <Link
                                    href={virtualTourLink || "#"}
                                    className="text-[10px] md:text-sm xl:text-base/[24px]! font-medium text-silverBlue text-center"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Virtual Tour
                                </Link> */}
                                <Link
                                    href={`${mapLink}`}
                                    className="flex gap-0 md:gap-1 items-center cursor-pointer text-[10px] md:text-sm xl:text-base/[24px]! font-medium text-silverBlue text-center"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <span className="h-3 md:h-5 w-3 md:w-5 flex shrink-0">
                                        <ImageComponent url="/images/home_data/google_map_logo.png" img_title="Google Maps" object_cover={false} width={20} height={20} />
                                    </span>
                                    <span className="text-[10px] md:text-sm lg:text-base/[24px]! font-medium text-silverBlue text-center cursor-pointer">Get Directions</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default StoreDetailCard